import { Link, useSearchParams } from "react-router";
import { useServices } from "../app/services";
import { useResource } from "../app/useResource";
import { PostCard } from "../components/cards";
import { EmptyState, PageHeader, ResourceView } from "../components/ui";

export function PostsPage() {
  const { api } = useServices();
  const [params] = useSearchParams();
  const value = Number(params.get("page") ?? 1);
  const page = Number.isInteger(value) && value >= 1 && value <= 100000 ? value : 1;
  const res = useResource("posts.list", () => api.getPosts(page), [page], ["posts", "library"]);
  // If visibility changed, a failed refresh must not leave old content visible.
  const resource = res.status === "ready" && res.refreshError
    ? { status: "error" as const, error: res.refreshError, reload: res.reload } : res;
  return <div className="page">
    <PageHeader title="みんなの投稿" lead="おすすめも、ここ好きも。新しい順に。" />
    <ResourceView resource={resource} what="投稿">
      {(result) => <>
        {result.items.length ? <ul className="post-list">
          {result.items.map((post) => <PostCard key={post.id} post={post} />)}
        </ul> : <EmptyState title={page === 1 ? "まだ投稿がありません" : "このページに投稿はありません"} icon="sparkle" />}
        <nav className="posts-pagination" aria-label="投稿一覧のページ">
          {page > 1 && <Link className="btn btn-secondary" to={page === 2 ? "/posts" : `/posts?page=${page - 1}`}>前のページ</Link>}
          <span>{page}ページ目</span>
          {result.has_more && <Link className="btn btn-secondary" to={`/posts?page=${page + 1}`}>次のページ</Link>}
        </nav>
      </>}
    </ResourceView>
  </div>;
}
